/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, email: NonNullable<unknown> }} Impersonation_Actingas1Inputs */

const tr_impersonation_actingas1 = /** @type {(inputs: Impersonation_Actingas1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taklit Modu: ${i?.name} (${i?.email}) olarak işlem yapılıyor`)
};

const en_impersonation_actingas1 = /** @type {(inputs: Impersonation_Actingas1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impersonation Mode: Acting as ${i?.name} (${i?.email})`)
};

/**
* | output |
* | --- |
* | "Impersonation Mode: Acting as {name} ({email})" |
*
* @param {Impersonation_Actingas1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const impersonation_actingas1 = /** @type {((inputs: Impersonation_Actingas1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_Actingas1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_impersonation_actingas1(inputs)
	return en_impersonation_actingas1(inputs)
});
export { impersonation_actingas1 as "impersonation_actingAs" }